import addError from '../../../utils/error.jsx';

export function request(userId) {
    return {
        type: 'BETSLIP_ASSIGN_REFERRED_REQUEST',
        userId
    };
}

export function error(userId, errors) {
    addError(errors);

    return {
        type: 'BETSLIP_ASSIGN_REFERRED_ERROR',
        userId,
        errors
    };
}

export function finish(userId) {
    return {
        type: 'BETSLIP_ASSIGN_REFERRED_FINISH',
        userId
    };
}

export function clear(userId) {
    return {
        type: 'BETSLIP_ASSIGN_REFERRED_CLEAR',
        userId
    };
}
